import { render, staticRenderFns } from "./ImageComp.vue?vue&type=template&id=3e088dc2&"
import script from "./ImageComp.vue?vue&type=script&lang=js&"
export * from "./ImageComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports